'use client'


//page
import Nav from './Nav';

export default function Generique() {

    return (
        <>
            <div className="bg-[url('img/back-proces.png')] bg-top bg-cover">
                <Nav />

                <div className="relative isolate px-6 pt-14 lg:px-8">

                    <div className="mx-auto max-w-7xl py-32">
                        <div className="text-left">
                            <h1 className="text-balance text-[80px] leading-[5.5rem] font-semibold tracking-tight text-white  max-w-[80%] ">
                                Générique
                            </h1>
                            <div className='mt-10 w-full'>
                                <p className='text-white text-[22px] leading-[2rem] font-medium'>
                                <i>notre procès</i> <br/><br/>
                                <u>Conception, écriture et mise en scène</u><br/>
                                Bérénice Hamidi et Gaëlle Marti<br/><br/>

                                <u>Distribution </u><br/>
                                Éric Massé, Adèle Gascuel/Astrid Chabrat-Kajdan, Stéphanie Hennette-Vauchez, Laure Ignace, Catherine Le Magueresse, Hélène Merlin-Kajman, Laure Murat, Marc Pichard, Romane Poncet, Mélis Demir, Amélie Djaoudo<br/><br/>

                                <u>Assistanat à la mise en scène</u><br/>
                                Astrid Chabrat-Kajdan<br/><br/>
                                <u>Collaboration artistique</u><br/>
                                Manon Worms<br/><br/>

                                <u>Conception lumière</u><br/>
                                Clément Fessy/Blandine Granier<br/><br/>

                                <u>Scénographie</u><br/>
                                Mathilde Vallantin-Dulac<br/><br/>

                                <u>Affiche</u><br/>
                                Philippe Squarzoni<br/><br/>

                                <u>Film</u><br/>
                                Emmanuel Manzano, Bérénice Hamidi et Gaëlle Marti <br/><br/>

                                Projet porté au sein de la compagnie Sorcières et compagnie <br/>Accompagnement en production et en administration Le Bureau des filles <br/><br/>Soutiens<br/>Théâtre du Point du Jour • Maison des Sciences de l’Homme Lyon Saint-Etienne • GIS GENRE • Métropole de Lyon • Barreau de Lyon • Universités Lyon 3 et Lyon 2 • Institut Universitaire de France
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
